/**
 * Whether two stacks are the same thing, and so whether one may be counted
 * with the other. It mirrors the server's own rule: the kind and the owner
 * together, because two skulls stack only when they came off the same
 * person, and the variant since 2026-10-21, because two of the Seven are
 * two Rings. Everything else in the world has neither, so for everything
 * else this is the id and nothing more.
 */
export function sameItem(a: { id: number; owner?: string; var?: string }, b: { id: number; owner?: string; var?: string }): boolean {
  return a.id === b.id && (a.owner ?? "") === (b.owner ?? "") && (a.var ?? "") === (b.var ?? "");
}
